import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";


const sidebarLinks = [
  { label: "AI Readiness Score", path: "/impact/ai-readiness" },
  { label: "Technology Assessment", path: "/impact/technology-assessment" },
  { label: "Operating Model Design", path: "/impact/operating-model" },
  { label: "Process / Cost Optimization", path: "/impact/process-optimization" },
  { label: "Digital Transformation Roadmap", path: "/impact/dt-roadmap" },
];

export default function Solutions() {
  const location = useLocation();
  const isRoot =
    location.pathname === "/impact" || location.pathname === "/impact/";

  return (
    <div className="about-layout">
      {/* ── Sidebar ── */}
      <aside className="about-sidebar">
        <p className="about-sidebar__heading">Solutions</p>
        <nav className="about-sidebar__nav">
          {sidebarLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                isActive
                  ? "about-sidebar__link about-sidebar__link--active"
                  : "about-sidebar__link"
              }
            >
              <span className="about-sidebar__dot" />
              {link.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* ── Main content ── */}
      <main className="about-main">
        {isRoot ? <Navigate to="/about/vision" replace /> : <Outlet />}
      </main>
    </div>
  );
}